import * as Yup from "yup";
import {
  AADHAR_VALIDATION, ALPHABETS_ONLY,
  ALPHABETS_ONLY_Msg, Aadhaar_Msg, AddresRemarks, Addres_Msg, CONTEXT_HEADING, EMAIL_VALIDATION, ERROR_MSG,
  MOBILE_VALIDATION, Mobile_Msg,
  PINCODE
} from "./RegularExpAndVar";
import { validateVerhoeff } from "../CommonFunctions/ValidAadhaarFunction";
import moment from "moment";

export function getMinimumEligibleDOB({ caste, isEws, isPh, isExServiceMen, exService }) {
  const cutoffDate = moment('2024-07-01');
  const maxAgeCapDOB = moment(cutoffDate).subtract(61, 'years'); // i.e., 1963-07-01

  let baseMinDOB;

  if (isPh === 'true') {
    baseMinDOB = moment('1970-07-01');
  } else if (
    ['ST', 'SC', 'SC-A', 'SC-B', 'SC-C', 'BC-A', 'BC-B', 'BC-C', 'BC-D', 'BC-E', 'SC-GR I', 'SC-GR II', 'SC-GR III'].includes(caste) ||
    isEws === 'true'
  ) {
    baseMinDOB = moment('1975-07-01');
  } else if (caste === 'OC') {
    baseMinDOB = moment('1980-07-01');
  } else {
    // Default fallback (if caste is empty or unknown)
    baseMinDOB = moment('1980-07-01');
  }

  // Apply ex-service relaxation if applicable
  if (isExServiceMen === 'true') {
    const serviceYears = parseInt(exService || 0, 10);
    const totalRelaxation = serviceYears + 3;
    baseMinDOB = baseMinDOB.subtract(totalRelaxation, 'years');
  }

  // Clamp to not go older than 61 years
  if (baseMinDOB.isBefore(maxAgeCapDOB)) {
    baseMinDOB = maxAgeCapDOB;
  }

  return baseMinDOB;
}
const today = moment();
const minAge = 18;
const maxAge = 80;
export const regValidationSchema = Yup.object().shape({
  aadhaarNo: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, Aadhaar_Msg).test("isValid", Aadhaar_Msg,
    function (value) {
      if (value) {
        return validateVerhoeff(value);
      }
      return true
    }),
  applicantName: Yup.string().required(ERROR_MSG).nullable().matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
  mobileNo: Yup.string().required(ERROR_MSG).nullable().matches(MOBILE_VALIDATION, Mobile_Msg),
  fatherName: Yup.string().required(ERROR_MSG).nullable().matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
  motherName: Yup.string().required(ERROR_MSG).nullable().matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
  gender: Yup.string().required(ERROR_MSG),
  maritalStatus: Yup.string().required(ERROR_MSG),
  caste: Yup.string().required(ERROR_MSG),
  subCasteCode: Yup.string().required(ERROR_MSG),
  isEws: Yup.string().when("caste", {
    is: (caste) => (caste === 'OC'),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string(),
  }),
  // dob: Yup.date()
  //   .required("Date of Birth is required")
  //   .test(
  //     "age-range",
  //     `Age must be between ${minAge} and ${maxAge} years`,
  //     (value) => {
  //       if (!value) return false;
  //       const birthDate = moment(value);
  //       const age = today.diff(birthDate, "years");
  //       return age >= minAge && age <= maxAge;
  //     }),

  dob: Yup.date()
    .required("Date of Birth is required")
    .test(
      "age-range",
      `Age must be between ${minAge} and ${maxAge} years`,
      function (value) {
        if (!value) return false;

        const today = moment().startOf("day");
        const birthDate = moment(value).startOf("day");

        const minAllowedDOB = today.clone().subtract(minAge, "years");
        const maxAllowedDOB = today.clone().subtract(maxAge, "years");

        return birthDate.isSameOrBefore(minAllowedDOB) &&
          birthDate.isSameOrAfter(maxAllowedDOB);
      }
    ).max(
      moment().subtract(18, "years").endOf("day").toDate(),
      "You must be at least 18 years old"
    ),
  // ********For dsc ******************
  // dob: Yup.date()
  //   .required(ERROR_MSG)
  //   .test('validDob', 'Invalid dob', function (value, context) {
  //     if (!value) return true;

  //     const { caste, isEws, isPh, isExServiceMen, exService } = context.parent;
  //     const cutoffDate = moment('2024-07-01');
  //     const minAgeDate = moment(cutoffDate).subtract(18, 'years');

  //     if (moment(value).isAfter(minAgeDate)) return false;

  //     const minEligibleDOB = getMinimumEligibleDOB({
  //       caste,
  //       isEws,
  //       isPh,
  //       isExServiceMen,
  //       exService,
  //     });

  //     return moment(value).isBetween(minEligibleDOB, cutoffDate, 'day', '[]');
  //   })
  //   .max(moment('2006-07-01').format('YYYY-MM-DD'), 'Must be at least 18 years old as of 01.07.2024'),
  // ********For dsc upto above ******************
  // dob: Yup.date()
  //   .required(ERROR_MSG)
  //   .test('validDob', 'Invalid dob', function (value) {
  //     if (!value) return true;

  //     const { caste, isEws, isPh, isExServiceMen, exService } = this.parent;
  //     const cutoffDate = moment('2024-07-01');
  //     const minAgeDate = moment(cutoffDate).subtract(18, 'years'); // Must be 18+ as of 01-Jul-2024

  //     if (moment(value).isAfter(minAgeDate, 'day')) {
  //       return false; // Underage
  //     }

  //     let baseMaxDOB;

  //     // Default DOB cutoff by caste
  //     if (isPh === 'true') {
  //       baseMaxDOB = moment('1970-07-01');
  //     } else if (
  //       ['ST', 'SC', 'SC-A', 'SC-B', 'SC-C', 'BC-A', 'BC-B', 'BC-C', 'BC-D', 'BC-E'].includes(caste) ||
  //       isEws === 'true'
  //     ) {
  //       baseMaxDOB = moment('1975-07-01');
  //     } else if (caste === 'OC') {
  //       baseMaxDOB = moment('1980-07-01');
  //     }

  //     // If ex-serviceman, apply relaxation
  //     if (isExServiceMen === 'true') {
  //       const serviceYears = parseInt(exService || 0, 10);
  //       const totalRelaxation = serviceYears + 3;

  //       // Adjust DOB by subtracting relaxation
  //       baseMaxDOB = baseMaxDOB?.subtract(totalRelaxation, 'years');
  //     }

  //     // Final check
  //     return baseMaxDOB && moment(value).isBetween(baseMaxDOB, cutoffDate, 'day', '[]');
  //   })
  //   .max(moment('2006-07-01').format('YYYY-MM-DD'), 'Invalid dob - Must be 18+ years as of 01.07.2024'),

  isGovSchool: CONTEXT_HEADING === "DSC" ? Yup.string().required(ERROR_MSG).nullable() : Yup.string().nullable(),
  managementId: Yup.string().when("isGovSchool", {
    is: (isGovSchool) => (isGovSchool === "true"),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string().nullable(),
  }),
  email: Yup.string().required(ERROR_MSG).nullable().matches(EMAIL_VALIDATION, 'Invalid email address'),
  doorNo: Yup.string().required(ERROR_MSG).nullable(),
  pinCode: Yup.string().matches(PINCODE, "Enter a valid PIN code").length(6, "PIN code must be exactly 6 digits").required(ERROR_MSG).nullable(),
  address: Yup.string().required(ERROR_MSG).nullable().matches(AddresRemarks, Addres_Msg),
  isExServiceMen: Yup.string().required(ERROR_MSG),
  exService: Yup.string().when("isExServiceMen", {
    is: (isNative) => (isNative === "true"),
    then: Yup.string().required(ERROR_MSG),
    oterwise: Yup.string(),
  }),
  isPh: Yup.string().required(ERROR_MSG),
  isScribe: Yup.string().when("isPh", {
    is: (isNative) => (isNative === "true"),
    then: Yup.string().required(ERROR_MSG),
    oterwise: Yup.string(),
  }),
  selfCheck: Yup.boolean().required(ERROR_MSG),
  vhPercentage: Yup.string().when("isVh", {
    is: (isNative) => (isNative === true),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string(),
  }),
  hiPercentage: Yup.string().when("isHi", {
    is: (isNative) => (isNative === true),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string(),
  }),
  ohPercentage: Yup.string().when("isOh", {
    is: (isNative) => (isNative === true),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string(),
  }),
  miPercentage: Yup.string().when("isMi", {
    is: (isNative) => (isNative === true),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string(),
  }),
  isAndhra: Yup.string().required(ERROR_MSG),
  state: Yup.string().when("isAndhra", {
    is: (isNative) => (isNative === "false"),
    then: Yup.string().required(ERROR_MSG).nullable(),
    oterwise: Yup.string(),
  }),
  district: Yup.string().when('isAndhra', {
    is: 'false',
    then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
    otherwise: Yup.string().required(ERROR_MSG),
  }),
  mandal: Yup.string().when('isAndhra', {
    is: 'false',
    then: Yup.string().required(ERROR_MSG).matches(ALPHABETS_ONLY, ALPHABETS_ONLY_Msg),
    otherwise: Yup.string().required(ERROR_MSG),
  }),
  village: Yup.string().when("isAndhra", {
    is: (isNative) => (isNative === "true"),
    then: Yup.string().required(ERROR_MSG).nullable(),
    otherwise: Yup.string().nullable(),
  }),
  // isTelangana: Yup.string().required(ERROR_MSG),
  // claimingDistrict: Yup.string().when("isTelangana", {
  //   is: (isNative) => (isNative === "true"),
  //   then: Yup.string().required(ERROR_MSG).nullable(),
  //   oterwise: Yup.string(),
  // }),
  // isSports: Yup.string().required(ERROR_MSG),
}).test("myCustomCheckboxTest", function (obj) {
  if (obj.isPh === "true") {
    if (obj.isOh || obj.isHi || obj.isMi || obj.isVh) {
      return true; // everything is fine
    }
    return new Yup.ValidationError(
      "Check at least one checkbox",
      null,
      "isMi");
  }
});


export const examCenterValidations = Yup.object().shape({
  option1: Yup.string()
    .required(ERROR_MSG)
    .test('unique', 'Option  is already selected', (value, context) => {
      if (value !== "") {
        const { option2, option3, option4, option5 } = context.parent;
        return value !== option2 && value !== option3 && value !== option4 && value !== option5;
      }
      return true
    }),
  option2: Yup.string()
    .required(ERROR_MSG)
    .test('unique', 'Option  is already selected', (value, context) => {
      if (value !== "") {
        const { option1, option3, option4, option5 } = context.parent;
        return value !== option1 && value !== option3 && value !== option4 && value !== option5;
      }
      return true
    }),
  option3: Yup.string()
    .required(ERROR_MSG)
    .test('unique', 'Option  is already selected', (value, context) => {
      if (value !== "") {
        const { option2, option1, option4, option5 } = context.parent;
        return value !== option2 && value !== option1 && value !== option4 && value !== option5;
      }
      return true
    }),
  option4: Yup.string()
    .required(ERROR_MSG)
    .test('unique', 'Option  is already selected', (value, context) => {
      if (value !== "") {
        const { option2, option3, option5, option1 } = context.parent;
        return value !== option2 && value !== option3 && value !== option5 && value !== option1;
      }
      return true
    }),
  option5: Yup.string()
    .required(ERROR_MSG)
    .test('unique', 'Option  is already selected', (value, context) => {
      if (value !== "") {
        const { option2, option3, option4, option1 } = context.parent;
        return value !== option2 && value !== option3 && value !== option4 && value !== option1;
      }
      return true
    }),
})